module.exports = __webpack_public_path__ + "static/media/Marymoore Patterson.e3ec973a.png";